import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import type { VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { variantes } from "./BotonVariantes";

function Button({
  className,
  variant,
  size,
  asChild = false,
  children,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof variantes> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  const iconSizeClass =
    size === "icon" &&
    React.isValidElement(children) &&
    typeof (children.props as { size?: unknown }).size === "number"
      ? `h-[${(children.props as { size: number }).size}px] w-[${
          (children.props as { size: number }).size
        }px]`
      : "";

  return (
    <Comp
      data-slot="button"
      className={cn(variantes({ variant, size, className }), iconSizeClass)}
      {...props}
    >
      {children}
    </Comp>
  );
}

export { Button };
